import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {Modal} from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import * as RegionMarketActionType from '../constants';
import pdf from 'assets/img/file_pdf.png';
import word from 'assets/img/file_word.png';
import image from 'assets/img/file_image.png';

class ConfigPOAttachments extends Component {

  static propTypes = {
    region: PropTypes.object,
    dispatch: PropTypes.func,
    onCloseModal: PropTypes.func,
    RegionPODocuments: PropTypes.array,
    RegionAWSCredential: PropTypes.object,
    show: PropTypes.bool
  }
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      cancelUploadList: {},
      deleteUploadList: {},
      error: null
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: RegionMarketActionType.GET_REGION_PO_ASYNC,
      params: {
        regionId: this.props.region.id
      }
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RegionMarketActionType.RESET_REGION_PO
    });
  }

  onCloseModal = () => {
    this.props.onCloseModal();
  }

  onDrop = (accepted, rejected) => {
    if (rejected.length) {
      this.setState({
        error: 'Only PDF, DOC, DOCX, PNG, JPG supported.'
      });
    } else {
      if (accepted.length + this.state.files.length + this.props.RegionPODocuments.length <= 10) {
        let newFiles = [...this.state.files];
        accepted.map((file) => {
          file.uploadId = _.uniqueId();
          newFiles.push(file);
          this.setState({
            files: newFiles
          });
        });
        this.setState({
          error: null
        });
        this.handleUploadFile(accepted);
      } else {
        this.setState({
          error: 'Maximum 10 files allowed.'
        });
      }
    }
  }

  handleUploadFile = (files) => {
    //call api to get key AWS
    this.props.dispatch({
      type: RegionMarketActionType.SETUP_REGION_PO_AWS_ASYNC,
      params: {
        resourcePath: `regions/${this.props.region.id}`
      },
      callback: () => this.handleUploadFileToS3(files)
    });
  }

  handleUploadFileToS3 = (files) => {
    files.map((file) => {
      this.props.dispatch({
        type: RegionMarketActionType.UPLOAD_REGION_PO_TO_S3_ASYNC,
        params: {
          regionId: this.props.region.id,
          config: this.props.RegionAWSCredential,
          file: file
        },
        callback: this.callbackHandleUploadFileToS3(file.name)
      });
    });
  }

  callbackHandleUploadFileToS3 = fileName => (status, data) => {
    if (status === 'pending') {
      const {cancelUploadList} = this.state;
      cancelUploadList[data.uploadId] = data.cancelUpload;
      this.setState({
        cancelUploadList
      });
    } else if (status === 'delete') {
      const {deleteUploadList} = this.state;
      deleteUploadList[data.uploadId] = data.deleteFile;
      this.setState({
        deleteUploadList
      });
    } else if (status === true) {
      this.handleUploadFileToServer(data.data, fileName);
    }
  }

  handleUploadFileToServer = (data, fileName) => {
    this.props.dispatch({
      type: RegionMarketActionType.UPLOAD_REGION_PO_TO_SERVER_ASYNC,
      params: {
        regionId: this.props.region.id,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName,
          caption: ''
        }
      },
      callback: (status, res) => {
        if (status) {
          this.setState({
            files: this.state.files.filter(element => element.name !== res[0].fileName)
          });
        }
      }
    });
  }

  handleCancelUpload = (item) => {
    const {cancelUploadList} = this.state;
    if (!isEmpty(cancelUploadList) && Object.keys(cancelUploadList).includes(item.uploadId)) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter((element) => element.uploadId !== item.uploadId),
        cancelUploadList
      });
    }
    const {deleteUploadList} = this.state;
    if (!isEmpty(deleteUploadList) && Object.keys(deleteUploadList).includes(item.uploadId)) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter((element) => element.uploadId !== item.uploadId),
        deleteUploadList
      });
    }
  }

  handleDownloadFile = (file) => {
    this.props.dispatch({
      type: RegionMarketActionType.SETUP_REGION_PO_AWS_ASYNC,
      params: {resourcePath: `regions/${this.props.region.id}`},
      callback: () => {
        this.props.dispatch({
          type: RegionMarketActionType.DOWNLOAD_REGION_PO_ASYNC,
          params: {
            config: this.props.RegionAWSCredential,
            fileName: file.fileName,
            key: file.key
          }
        });
      }
    });
  }

  handleDeleteFile = (file) => {
    this.props.dispatch({
      type: RegionMarketActionType.REMOVE_REGION_PO_ASYNC,
      params: {
        id: this.props.region.id,
        docId: file.id
      }
    });
  }

  renderFileType = (file) => {
    // const extImage = ['jpg', 'jpeg', 'png', 'gif'];
    const ext = file.fileName.split('.').pop().toLowerCase();
    if (ext === 'pdf') {return pdf;}
    else if (ext === 'doc' || ext === 'docx') {return word;}
    else {return image;}
  }

  render() {
    return <Modal show={this.props.show} className='config-po-modal'>
      <p className='title'>Purchase order attachments for {this.props.region.name}</p>
      <div className='config-po-header-info'>
        <i className='fa fa-question-circle'/>
        <span>This is where you config additional attachments to send along with a purchase order if needed.</span>
      </div>
      <div className='config-po-attachment-block'>
        <p className='attachment-header'>Attachments</p>
        {this.state.error && <span className='text-danger'>{this.state.error}</span>}
        {
          this.props.RegionPODocuments.map(f =>
            <div key={f.name} style={{margin: '10px 0'}}>
              <img src={this.renderFileType(f)} style={{height: 25, verticalAlign: 'bottom'}} />
              <span style={{margin: '0 10px'}}>{f.fileName}</span>
              <i className='fa fa-trash remove-ic right-col-ic' style={{cursor: 'pointer'}} onClick={() => this.handleDeleteFile(f)} />
            </div>
          )
        }
        {
          this.state.files.map(f =>
            <div key={f.name} style={{margin: '10px 0'}}>
              <i className='fa fa-spin fa-spinner loading-ic' />
              <span style={{margin: '0 10px'}}>{f.name}</span>
              <i className='fa fa-trash remove-ic right-col-ic' style={{cursor: 'pointer'}} onClick={() => this.handleCancelUpload(f)} />
            </div>
          )
        }
        <Dropzone
          accept='.pdf, .doc, .docx, application/pdf, application/msword, image/jpeg, image/png'
          disableClick
          ref={(node) => {this.dropzoneRef = node;}}
          onDrop={this.onDrop}
          style={{position: 'initial'}}>
          <span className='add-btn' onClick={() => {this.dropzoneRef.open();}}>+ Add new attachment</span>
        </Dropzone>
      </div>
      <button
        className='btn btn-primary btn-siteone'
        onClick={this.onCloseModal}
        disabled={this.state.files.length}>Done</button>
    </Modal>;
  }
}

const mapStateToProps = (state) => {
  return {
    RegionAWSCredential: state.RegionMarketStore.RegionAWSCredential,
    RegionPODocuments: state.RegionMarketStore.RegionPODocuments
  };
};

export default connect(mapStateToProps)(ConfigPOAttachments);



// WEBPACK FOOTER //
// ./src/Region-Market/Containers/config-po-attachments.js